<template>
  <v-container fluid grid-list-xl>
    <v-layout>
      <v-flex xl6 offset-xl3 lg8 offset-lg2 xs12 offset-xs0>
        <v-card>
          <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>
          <notifications group="my-information" key="my-information" />

          <v-card-text>
            <v-form ref="form">
              <v-layout>
                <v-flex xs6>
                  <v-text-field
                    label="Firma/Navn"
                    v-model="info.companyName"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Postnr"
                    v-model="info.zipCode"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Land"
                    v-model="info.country"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Telefon"
                    v-model="info.phone"
                  ></v-text-field>
                  <v-text-field
                    label="Org. nummer"
                    v-model="info.orgNumber"
                  ></v-text-field>
                </v-flex>

                <v-flex xs6>
                  <v-text-field
                    label="Adresse"
                    v-model="info.address"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Poststed"
                    v-model="info.city"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Deres ref"
                    v-model="info.yourReference"
                  ></v-text-field>
                  <v-text-field
                    label="Mobil"
                    v-model="info.mobile"
                  ></v-text-field>
                  <v-text-field
                    label="Webadresse"
                    v-model="info.webAddress"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12>
                  <v-checkbox
                    label="Jeg vil ha faktura i posten (tilkommer gebyr kr. 50)"
                    v-model="info.invoiceByMail"
                  ></v-checkbox>

                  <v-btn color="green darken-3" dark @click="saveInformation">
                    Lagre endringer
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>

        <v-card style="margin-top: 30px;">
          <notifications group="my-information-contacts" key="my-information-contacts" />

          <v-card-text>
            <h2>Kontaktpersoner</h2>

            <v-btn
              fab
              absolute top right
              dark
              color="green darken-2"
              @click.native="createDialog()"
            >
              <v-icon>add</v-icon>
            </v-btn>

            <v-layout row wrap>
              <v-flex
                v-for="contact in contacts"
                :key="'contact-' + contact.id"
                md4 sm6 xs12
              >
                <v-card>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="indigo">person</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>
                          {{ contact.name }}
                          <span :title="contact.types.join(', ')">
                            ({{ contact.types.join(', ') }})
                          </span>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="indigo">phone</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>{{ contact.phone }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="indigo">mail</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>{{ contact.email }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="indigo">location_on</v-icon>
                      </v-list-tile-action>

                      <v-list-tile-content>
                        <v-list-tile-title>{{ contact.address }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-btn flat @click.native="editDialog(contact)">Rediger kontakt</v-btn>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <edit-contact :state="dialogState" @remove="onRemoveContact" @create="onCreateContact" @save="onSaveContact" />
  </v-container>
</template>

<script>
import InformationService from '@/services/InformationService'
import EditContact from '@/components/EditContact'
import _ from 'lodash'

export default {
  name: 'my-information',
  mounted () {
    this.init()
  },
  data () {
    return {
      contacts: [],
      info: {},
      dialogState: {
        open: false,
        contact: {}
      },
      isSubmitting: false
    }
  },
  methods: {
    async init () {
      this.contacts = []
      this.info = {}

      const infoResponse = await this.runService(this, 'my-information', InformationService.getInformation)
      if (infoResponse) {
        this.info = infoResponse.data
      }

      const contactResponse = await this.runService(this, 'my-information-contacts', InformationService.getContactList)
      if (contactResponse) {
        this.contacts = contactResponse.data
      }
    },
    async saveInformation () {
      const response = await this.runService(this, 'my-information', InformationService.saveInformation, this.info)
      if (response) {
        this.info = response.data

        const newCustomer = response.data

        /* Need to change the store since we're showing the customers in the page header */
        const newCustomers = _.cloneDeep(this.$store.state.customers)
        const i = _.findIndex(newCustomers, _.matchesProperty('customerNumber', newCustomer.customerNumber))
        newCustomers.splice(i, 1, response.data)

        this.$store.dispatch('setCustomers', newCustomers)
        this.$store.dispatch('setCustomer', newCustomer)

        this.addNotification(true, {
          group: 'my-information',
          type: 'success',
          text: 'Endringene ble lagret'
        })
      }
    },
    onRemoveContact (id) {
      const i = _.findIndex(this.contacts, _.matchesProperty('id', id))
      this.contacts.splice(i, 1)
      this.dialogState.open = false
    },
    onCreateContact (contact) {
      this.contacts.push(contact)
      this.dialogState.open = false
    },
    onSaveContact (id, contact) {
      const i = _.findIndex(this.contacts, _.matchesProperty('id', id))
      this.contacts.splice(i, 1, contact)
      this.dialogState.open = false
    },
    editDialog: function (contact) {
      this.dialogState.contact = _.cloneDeep(contact)
      this.dialogState.open = true
    },
    createDialog: function () {
      this.dialogState.contact = {
        name: '',
        types: [],
        address: '',
        phone: '',
        email: ''
      }
      this.dialogState.open = true
    }
  },
  components: {
    EditContact
  }
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
}

.contact {
  margin-top: 12px;
  border: 1px solid #aaa;
}
</style>
